import { useEffect } from 'react';
export const useEkomiWidgetScript = () => {
  useEffect(() => {
    // eslint-disable-next-line max-len
    const ekomiScriptContent = 'function registerWidget(e,t){if(e._ekomiWidgetsServerUrl="https://widgets.ekomi.com",e._customerId=152944,null==e._language&&(e._language=new Array),e._language[t]="auto",void 0!==e._ekomiWidgetTokens?e._ekomiWidgetTokens[e._ekomiWidgetTokens.length]=t:e._ekomiWidgetTokens=new Array(t),"undefined"==typeof ekomiWidgetJs){ekomiWidgetJs=!0;var i=document.createElement("script");i.src="https://sw-assets.ekomiapps.de/static_resources/widget.js",document.getElementsByTagName("head")[0].appendChild(i)}else"undefined"!=typeof ekomiWidgetMain&&ekomiWidgetMain("ajax",t);return!0}!function(e){for(var t="sf1529446596c4ce725f4",i=document.getElementsByClassName("ekomi-widget-"+t),n=0;n<i.length;n++)registerWidget(e,t)}(window)';
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.defer = true;
    script.innerHTML = ekomiScriptContent;
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);
};